import { htmlEncode } from '../../utils/escape.utils';
import { translateFn } from '../../utils/translator.helper';

export function dataGridStrings() {
  return {
    noOptionsFound: htmlEncode(translateFn('No options found')),
    actionButtonString: htmlEncode(translateFn('Apply')),
    noSearchResultsString: htmlEncode(translateFn('No results found.')),
    dataLoadingFailed: htmlEncode(
      translateFn(
        'Data loading has failed. Please try to refresh the page and if the issue persists contact Bitdefender Enterprise Support for more information.'
      )
    ),
    summaryTimeoutError: htmlEncode(
      translateFn('Determining the number of items took too long. Please adjust your filters and try again')
    ),
    searchPlaceholderString: htmlEncode(translateFn('Search')),
    searchColumnsPlaceholderString: htmlEncode(translateFn('Search columns')),
    compactViewString: htmlEncode(translateFn('Compact view')),
    settingsTitle: htmlEncode(translateFn('Settings')),
    noColumnsFound: htmlEncode(translateFn('No columns found')),
    resetViewString: translateFn('Reset view'),
    resetFiltersString: translateFn('Reset filters'),
    selectAll: htmlEncode(translateFn('Select all')),
    stringFilterPlaceholder: htmlEncode(translateFn('type here')),
    loadingCSVExportTooltip: htmlEncode(translateFn('Exporting view')),
    cSVExportTooltip: htmlEncode(translateFn('Export view')),
    favoriteIconFilledTooltip: htmlEncode(translateFn('Remove from favorites')),
    favoriteIconOutlineTooltip: htmlEncode(translateFn('Add to favorites')),
    enumColumnStrings: {
      confirmString: htmlEncode(translateFn('Apply')),
      allItemsLabel: htmlEncode(translateFn('All')),
    },
    allDirectManagement: translateFn('All directly managed'),
    allRecursive: translateFn('All recursively'),
    toggleFiltersVisibilityTooltip: translateFn('Show or hide filters'),
    refreshBtnTooltip: translateFn('Refresh'),
    gridSettingsMenuTriggerTooltip: translateFn('Open Settings'),
  };
}
